import styled from "styled-components";

export const Description = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  gap: 20px;

  img {
    max-width: 560px;
    width: 100%;
  }
`;
